import React, { Component } from 'react';
class CalendarDates extends Component {
  constructor() {
    super();
    this.state = {
      dates_data:'',
    };
  }


componentDidMount(){
  var dates = this.props.all_dates_data;
  var dates_new = dates['calendar'];
  this.convert_dates(dates_new);
}


convert_dates(dates){
  var event_month = this.props.event_month;
  var holiday_master = this.props.holiday;
  var week_day_name = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var dates_len = dates.length;
  var dates_data = [];
  for(var i=0; i<dates_len;i++){
    var sub_data = [];
    var sub_array = dates[i];
    for(var j=0; j<sub_array.length;j++){
      var className = '';
      if(sub_array[j]==null){className = 'no_date';}
      var holiday = '';
      if(j==0 && sub_array[j]!=null){holiday='holiday';}
      var date_no_v = sub_array[j];
      var event_data_view = [];
      var holiday_data_view = [];
      if(date_no_v!==null){
        var date_event_data = event_month[date_no_v];
        if(date_event_data.length>0){
          for(var rd=0; rd<date_event_data.length;rd++){
            var r_data = date_event_data[rd]['data'];
            var event_title = r_data['event_title'];
            var envet_from_time = window.formatTime(r_data['envet_from_time']);
            var envet_to_time = window.formatTime(r_data['envet_to_time']);
            event_data_view.push(<a className="pointer" title={event_title}>
              <p className="calendar_event_p">{event_title.substring(0,15)}</p>
              <p className="calendar_event_p">{envet_from_time+" To "+envet_to_time}</p>
              </a>);
          }
        }

        var date_holiday = holiday_master[date_no_v];
        if(date_holiday.length>0){
          holiday='holiday';
          for(var hd=0; hd<date_holiday.length;hd++){
            var holiday_title = date_holiday[hd]['holiday_title'];
            holiday_data_view.push(<a className="pointer">
              <p className="calendar_event_p">{holiday_title}</p>
              </a>);
          }
        }

      }




    sub_data.push(<div class={"weekday calendar_heading "+className+" "+holiday}>{sub_array[j]}{event_data_view}{holiday_data_view}</div>);
    }
    dates_data.push(<div class="weekdays_date clearfix"> {sub_data} </div>);
  }
  this.setState({dates_data});
}

  render() {
    return (
        <>
        {this.state.dates_data}
        </>
    );
  }
}

export default CalendarDates;
